// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomQuoteParameter } from "@ces/App/Handlers/CustomRfqRequestQuote/RfqRequestQuoteState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

interface RfqCustomRequestQuoteState {
    accounts: AccountModel[];
    quoteParameter: CustomQuoteParameter;
    isSubmitted: boolean;
    errorMessage: string;
}

const initialState: RfqCustomRequestQuoteState = {
    accounts: [],
    quoteParameter: {
        firstName: "",
        lastName: "",
        companyName: "",
        customerType: "",
        position: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        fax: "",
        email: "",
        notes: "",
        cartId: "",
        poNumber: "",
    },
    isSubmitted: false,
    errorMessage: "",
};

const reducer = {
    "Pages/RfqCustomRequestQuote/CompleteLoadAccounts": (
        draft: Draft<RfqCustomRequestQuoteState>,
        action: { collection: AccountModel[] },
    ) => {
        draft.accounts = action.collection;
    },

    "Pages/RfqCustomRequestQuote/UpdateQuoteParameter": (
        draft: Draft<RfqCustomRequestQuoteState>,
        action: { parameter: CustomQuoteParameter },
    ) => {
        draft.quoteParameter = { ...draft.quoteParameter, ...action.parameter };
    },

    "Pages/RfqCustomRequestQuote/SetIsSubmitted": (
        draft: Draft<RfqCustomRequestQuoteState>,
        action: { parameter: boolean },
    ) => {
        draft.isSubmitted = action.parameter;
    },
    "Pages/RfqCustomRequestQuote/Reset": (draft: Draft<RfqCustomRequestQuoteState>) => {
        draft.quoteParameter = {};
    },
    "Pages/RfqCustomRequestQuote/SetErrorMessage": (
        draft: Draft<RfqCustomRequestQuoteState>,
        action: { errorMessage: string },
    ) => {
        draft.errorMessage = action.errorMessage;
    },
    "Pages/RfqCustomRequestQuote/ResetErrorMessage": (draft: Draft<RfqCustomRequestQuoteState>) => {
        draft.errorMessage = initialState.errorMessage;
    },
};

const xRfqCustomCreateQuote = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xRfqCustomCreateQuote = xRfqCustomCreateQuote;

export type xRfqCustomRequestQuoteState = {
    xRfqCustomCreateQuote: RfqCustomRequestQuoteState;
} & ApplicationState;

type xRfqCustomCreateQuoteReducers = {
    [key: string]: typeof xRfqCustomCreateQuote;
};

export type xRfqCustomCreateQuoteActions =
    | Parameters<xRfqCustomCreateQuoteReducers[keyof xRfqCustomCreateQuoteReducers]>[1]
    | AnyAction;
